// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3CJ_5","errorLogs":"EditorFooter_errorLogs__1n4ir"};